
const digest = 'cb22e4967816340acdc2700060a4aaf336924dd20eba24873f2bed352b4e7252';
const classes = {"wrapper":"_wrapper_1b9jr_1","title":"_title_1b9jr_10"};
const css = `._wrapper_1b9jr_1 {
  padding: 12px 24px;
  background: #fbfbfd;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

._title_1b9jr_10 {
  font-size: 18px;
  color: #000;
  font-weight: 500;
  flex-shrink: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  